export const SPACE = 4
export const TARGET_LINE_HALF_HEIGHT = 2
export const DRAGGABLE_BLOCK_MENU_CLASSNAME = 'draggable-block-menu'
export const DRAG_DATA_FORMAT = 'application/x-lexical-drag-block'
export const TEXT_BOX_HORIZONTAL_PADDING = 28
export const DIVIDER_TO_HALF = 2
export const POSITION_FOR_HIDE_ELEMENT = '-10000px'

export const Downward = 1
export const Upward = -1
export const Indeterminate = 0
